export default __webpack_public_path__ + "static/media/ic_coin.9b1b5631.svg";